import React, { useEffect, useContext, useState } from "react";
import { Container, Navbar, Nav, Image } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../App.scss";
import search from "../../assets/search-logo.svg";
import { Link } from "react-router-dom";
import axios from "axios";
import { UserContext } from "../../use_context";
import NavDropdown from "react-bootstrap/NavDropdown";
import Offcanvas from "react-bootstrap/Offcanvas";
import Slideshow from "./slideshow";

const API_BASE_URL = process.env.REACT_APP_SEARCH_API;

const Preloader = () => (
  <div className="loader-mask">
    <div className="loader"></div>
  </div>
);

const useFadeInOnScroll = () => {
  useEffect(() => {
    const handleFadeIn = () => {
      const fadeSections = document.querySelectorAll(".fade-in-viewport");
      fadeSections.forEach((section) => {
        if (isInViewport(section) && !section.classList.contains("faded-in")) {
          section.classList.add("faded-in");
          section.classList.add("fade-in");
        }
      });
    };

    const isInViewport = (element) => {
      const rect = element.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <=
          (window.innerWidth || document.documentElement.clientWidth)
      );
    };

    window.addEventListener("scroll", handleFadeIn);
    handleFadeIn(); // Initial check on page load

    return () => {
      window.removeEventListener("scroll", handleFadeIn);
    };
  }, []);
};

function HomePage() {
  const [offcanvasOpen, setOffcanvasOpen] = useState(false);
  const [loading, setLoading] = useState(true);

  const { sliderImages, setSliderImages } = useContext(UserContext);

  const handleOffcanvasToggle = () => {
    setOffcanvasOpen(!offcanvasOpen);
  };

  const handleOffcanvasClose = () => {
    setOffcanvasOpen(false);
  };

  const getImageDetails = async (imageId) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/media/${imageId}`);
      return response?.data?.source_url || null;
    } catch (error) {
      console.error("Error fetching image details:", error);
      return null;
    }
  };

  useEffect(() => {
    if (sliderImages.length === 0) {
      axios
        .get(`${API_BASE_URL}/pages/8`)
        .then(async (response) => {
          const aPIReturnData = response?.data?.acf?.slider || [];
          const APIReturnedImages = [];
          for (const imageData of aPIReturnData) {
            const imageUrl = await getImageDetails(imageData.image);
            if (imageUrl) {
              APIReturnedImages.push(imageUrl);
            }
          }
          setSliderImages(APIReturnedImages);
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching slider images:", error);
          alert("Error fetching slider images");
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, [sliderImages, setSliderImages]);

  useFadeInOnScroll();

  useEffect(() => {
    if (!loading) {
      document.body.classList.add("page-loaded");
    }
  }, [loading]);

  return (
    <div>
      {loading && <Preloader />}
      <header className="fixed header-transparent wide-container">
        <Container className="navigation-wrapper" fluid>
          <Navbar expand="lg" className="nav-row first-row">
            <Navbar.Brand href="#home" className="brand-logo">
              <img
                src={search}
                width="178px"
                height="33px"
                alt="React Bootstrap logo"
              />
            </Navbar.Brand>
            <Navbar.Toggle
              aria-controls="basic-navbar-nav"
              onClick={handleOffcanvasToggle}
            />
            <Navbar.Offcanvas
              id="offcanvasNavbar"
              aria-labelledby="offcanvasNavbarLabel"
              placement="end"
              className="home-offcanvas-custom"
              show={offcanvasOpen}
              onHide={handleOffcanvasClose}
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title id="offcanvasNavbarLabel"></Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Navbar.Collapse id="basic-navbar-nav" className="ms-auto">
                  <Nav className="menu list-inline custom-ml" id="menu">
                    <NavDropdown.Item href="#action3">
                      <Nav.Link
                        className={offcanvasOpen ? "black-text" : "white-text"}
                        href="/Office"
                      >
                        Office
                      </Nav.Link>
                    </NavDropdown.Item>
                    <NavDropdown.Item href="#action3">
                      <Link to="/works" className="text-decoration-none">
                        <Nav.Link
                          className={
                            offcanvasOpen ? "black-text" : "white-text"
                          }
                          href="/Works"
                        >
                          Works
                        </Nav.Link>
                      </Link>
                    </NavDropdown.Item>
                    <NavDropdown.Item href="#action3">
                      <Nav.Link
                        className={offcanvasOpen ? "black-text" : "white-text"}
                        href="/News"
                      >
                        News
                      </Nav.Link>
                    </NavDropdown.Item>
                    <NavDropdown.Item href="#action3">
                      <Nav.Link
                        className={offcanvasOpen ? "black-text" : "white-text"}
                        href="/Contact"
                      >
                        Contact
                      </Nav.Link>
                    </NavDropdown.Item>
                  </Nav>
                </Navbar.Collapse>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Navbar>
        </Container>
      </header>
      <main>
        <section className="page-hero viewport-height hero-overlay-top">
          {sliderImages && sliderImages.length ? (
            <Slideshow images={sliderImages} interval={3000} /> // Use the custom Slideshow component
          ) : null}

          <div className="fog-wrapper absolute inset">
            <div id="foglayer_01" className="fog">
              <div className="image01"></div>
              <div className="image02"></div>
            </div>
            <div id="foglayer_02" className="fog">
              <div className="image01"></div>
              <div className="image02"></div>
            </div>
            <div id="foglayer_03" className="fog">
              <div className="image01"></div>
              <div className="image02"></div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}

export default HomePage;

// import React, { useEffect, useContext, useState } from "react";
// import { Container, Navbar, Nav, Carousel, Image } from "react-bootstrap";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "../../App.scss";
// // import '../../style/components/header.scss'
// import search from '../../assets/search-logo.svg'
// import { Link } from "react-router-dom";
// import axios from "axios";
// import { UserContext } from "../../use_context";
// import NavDropdown from "react-bootstrap/NavDropdown";
// import Offcanvas from "react-bootstrap/Offcanvas";

// const API_BASE_URL = process.env.REACT_APP_SEARCH_API;

// function HomePage() {

//   const [offcanvasOpen, setOffcanvasOpen] = useState(false);

//   const handleOffcanvasToggle = () => {
//     setOffcanvasOpen(!offcanvasOpen);
//   };
//   const handleOffcanvasClose = () => {
//     setOffcanvasOpen(false); // Set offcanvasOpen state to false when offcanvas is closed
//   };

//   const { sliderImages, setSliderImages } = useContext(UserContext);
//   const getImageDetails = async (imageId) => {
//     try {
//       const response = await axios.get(`${API_BASE_URL}/media/${imageId}`);
//       return response?.data?.source_url || null;
//     } catch (error) {
//       console.error("Error fetching image details:", error);
//       return null;
//     }
//   };

//   useEffect(() => {
//     if (sliderImages.length === 0) {
//       axios
//         .get(`${API_BASE_URL}/pages/8`)
//         .then(async (response) => {
//           const aPIReturnData = response?.data?.acf?.slider || [];
//           const APIReturnedImages = [];
//           for (const imageData of aPIReturnData) {
//             const imageUrl = await getImageDetails(imageData.image);
//             if (imageUrl) {
//               APIReturnedImages.push(imageUrl);
//             }
//           }
//           setSliderImages(APIReturnedImages);
//         })
//         .catch((error) => {
//           console.error("Error fetching slider images:", error);
//           alert("Error fetching slider images");
//         });
//     }
//   }, []);

//   return (
//     <div >
//       <header className="fixed header-transparent wide-container">
//         <Container className="navigation-wrapper" fluid>
//        <Navbar expand="lg" className="nav-row first-row ">
//   <Navbar.Brand href="#home" className="brand-logo">
//     <img
//       src={search}
//       width="178px"
//       height="33px"
//       alt="React Bootstrap logo"
//     />
//   </Navbar.Brand>
//   <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={handleOffcanvasToggle} />
//   <Navbar.Offcanvas
//     id="offcanvasNavbar"
//     aria-labelledby="offcanvasNavbarLabel"
//     placement="end"
//     className="home-offcanvas-custom"
//     show={offcanvasOpen}
//     onHide={handleOffcanvasClose}

//   >
//     <Offcanvas.Header closeButton>
//       <Offcanvas.Title id="offcanvasNavbarLabel">
//       </Offcanvas.Title>
//     </Offcanvas.Header>
//     <Offcanvas.Body>
//       <Navbar.Collapse id="basic-navbar-nav">
//         <Nav className=" menu list-inline custom-ml" id="menu">
//           <NavDropdown.Item href="#action3">
//             <Nav.Link className={offcanvasOpen ? "black-text" : "white-text"} href="/Office">Office</Nav.Link>
//           </NavDropdown.Item>
//           <NavDropdown.Item href="#action3">
//             <Link to="/works" className="text-decoration-none">
//               <Nav.Link className={offcanvasOpen ? "black-text" : "white-text"} href="/Works">Works</Nav.Link>
//             </Link>
//           </NavDropdown.Item>
//           <NavDropdown.Item href="#action3">
//             <Nav.Link className={offcanvasOpen ? "black-text" : "white-text"} href="/News">News</Nav.Link>
//           </NavDropdown.Item>
//           <NavDropdown.Item href="#action3">
//             <Nav.Link className={offcanvasOpen ? "black-text" : "white-text"} href="/Contact">Contact</Nav.Link>
//           </NavDropdown.Item>
//         </Nav>
//       </Navbar.Collapse>
//     </Offcanvas.Body>
//   </Navbar.Offcanvas>
// </Navbar>
//         </Container>
//       </header>
//       <main>
//         <section className="page-hero viewport-height hero-overlay-top">
//           {sliderImages && sliderImages.length ? (
//             <Carousel className="slider viewport-height">
//               {sliderImages.map((image) => {
//                 return (
//                   <Carousel.Item className="viewport-height slider-item">
//                     <Image
//                     // style={{height:"400px"}}
//                       className="d-block w-100 object-cover object-center img-res"
//                       src={image}
//                       alt=""
//                       // height={400}
//                       // width={1000}
//                       fluid
//                      />
//                   </Carousel.Item>
//                 );
//               })}
//             </Carousel>
//           ) : null}

//           <div className="fog-wrapper absolute inset">
//             <div id="foglayer_01" className="fog">
//               <div className="image01"></div>
//               <div className="image02"></div>
//             </div>
//             <div id="foglayer_02" className="fog">
//               <div className="image01"></div>
//               <div className="image02"></div>
//             </div>
//             <div id="foglayer_03" className="fog">
//               <div className="image01"></div>
//               <div className="image02"></div>
//             </div>
//           </div>
//         </section>
//       </main>

//     </div>
//   );
// }

// export default HomePage;
